import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VESSEL_LAST_PORT_CALLS, TVesselLastPortCallsSliceState, TVesselInfo } from '../mapTypes';

const initialState: TVesselLastPortCallsSliceState = {
    vesselLastPortCallsData: null,
    vesselLastPortCallsLoading: false,
    vesselLastPortCallsError: null,
};

const vesselLastPortCallsSlice = createSlice({
    name: VESSEL_LAST_PORT_CALLS,
    initialState,
    reducers: {
        emptyVesselLastPortCallsAction: (state: TVesselLastPortCallsSliceState) => {
            state.vesselLastPortCallsData = null;
            state.vesselLastPortCallsLoading = false;
            state.vesselLastPortCallsError = null;
        },
        getVesselLastPortCallsRequestAction: (state: TVesselLastPortCallsSliceState, _: PayloadAction<{ imoNumber: number, startDate: string, endDate: string }>) => {
            state.vesselLastPortCallsLoading = true;
            state.vesselLastPortCallsError = null;
        },
        getVesselLastPortCallsSuccessAction: (
            state: TVesselLastPortCallsSliceState,
            { payload: data }: PayloadAction<TVesselInfo>,
        ) => {
            state.vesselLastPortCallsLoading = false;
            state.vesselLastPortCallsData = data;
            state.vesselLastPortCallsError = null;
        },
        getVesselLastPortCallsErrorAction: (
            state: TVesselLastPortCallsSliceState,
            { payload: error }: PayloadAction<any>,
        ) => {
            state.vesselLastPortCallsData = null;
            state.vesselLastPortCallsLoading = false;
            state.vesselLastPortCallsError = {
                message: (error.response && error.response.data) || error.message || '',
                name: error.name,
                stack: error.stack,
            };
        },
    },
});

export const { emptyVesselLastPortCallsAction, getVesselLastPortCallsRequestAction, getVesselLastPortCallsErrorAction, getVesselLastPortCallsSuccessAction } =
    vesselLastPortCallsSlice.actions;
export default vesselLastPortCallsSlice.reducer;